import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import InstructorCodesTable from './Pages/InstructorCodesTable/InstructorCodesTable';

const InstructorCodes = () => {
	const { url } = useRouteMatch();
	return (
		<div>
			<Switch>
				<Route path={url} component={InstructorCodesTable} />
			</Switch>
		</div>
	);
};

export default InstructorCodes;
